import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-building-application-approve-dialog',
  templateUrl: './building-application-approve-dialog.component.html',
  styleUrl: './building-application-approve-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingApplicationApproveDialogComponent {
  @Input() id!: string;
  readonly internalNumber = signal<string>('');

  submitAction = () => {
    return {
      id: this.id,
      internalNumber: this.internalNumber().trim()
    };
  };
}
